<template>
  <div class="width-full pointer" @click="goTodetail">
    <div class="float-left pa-2">
      <div class="pt-2">
        <span class="chatclass" v-bind:class="trades.ClosedProfitLoss > 0 ? 'up':'down'">
          <v-icon
            style="padding-bottom: 3px"
            color="#79C04D"
            size="18"
            v-if="trades.ClosedProfitLoss > 0"
            class="up"
          >check_circle</v-icon>
          <v-icon style="padding-bottom: 3px" color="#E62163" size="18" v-else class="down">cancel</v-icon>

          <b>
            <span v-if="trades.TradeType == 1" class="ml-1">Closed Long</span>
            <span v-else class="ml-1">Closed Short</span>
          </b>
        </span>
      </div>
    </div>
    <div class="pa-2 float-left">
      <div class="float-left">
        <div class="pa-0 text-lightgrey">{{time}}</div>
        <div style="margin-top:-3px">
          <b>{{trades.Symbol.pool}} | {{trades.MaxOpenQuantity}} pcs</b>
        </div>
      </div>
      <div class="float-right mt-3 ml-0">
        <v-tooltip v-if="trades._prepare" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" color="#4dbac0" class="mr-0">hourglass_empty</v-icon>
              </template>
              <span>prepared trade</span>
            </v-tooltip>

            <v-tooltip v-if="trades._entryLevel" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" color="#4dbac0" class="mr-0">calendar_view_day</v-icon>
              </template>
              <span>trade in zone</span>
            </v-tooltip>
      </div>
    </div>

    <div class="pa-2 float-right" style="float: right">
      <div class="pt-2" style="text-align:right">
        <span class="trades-pl">
          <span
            class="pl-font"
            v-bind:class="trades.ClosedProfitLoss > 0 ? 'up' : 'down'"
          >$ {{trades.ClosedProfitLoss.toFixed(2)}}</span>
          <v-btn @click="goTodetail" icon>
          <v-icon class="mx-2" color="#808F9C">keyboard_arrow_right</v-icon>
          </v-btn>
        </span>
        
      </div>
    </div>
  </div>
</template>

<script>
var moment = require("moment-timezone");
export default {
  components: {},
  props: { trades: Object },
  data() {
    return {
      time: this.trades.createdAt
    };
  },
  filters: {},
  methods: {
    goTodetail() {
      return this.$router.push({ path: "/trades/" + this.$route.params.name +"/"+ this.trades.openTimestamp});
    },
    updateTiems() {
      this.time = moment
        .tz(this.trades.createdAt, this.$store.getters.timezone)
        .format("hh:mm");
    }
  },
  mounted() {
    this.updateTiems();
    setInterval(() => {
      this.updateTiems();
    }, 1000);
  },

  computed: {}
};
</script>

<style scoped>
</style>
